import { useMemo } from 'react';

import type { DomainQueryOptions } from '@/domain/shared/types';
import { useSmoltReportController_listReports } from '@/services/hooks';
import type { SmoltReportListResponseDto } from '@/services/types';

import { mapSmoltReportListToDomain } from './mappers';
import type { UseGetListReportsResult } from './types';

/**
 * Domain hook to fetch the list of smolt reports for a cage.
 *
 * @param cageId - The cage ID to fetch reports for
 * @param options - Optional React Query options (e.g. enabled, refetchInterval)
 * @returns Query result with mapped list of smolt report items
 */
export const useGetListReports = (
    cageId: number,
    options?: DomainQueryOptions<SmoltReportListResponseDto[]>
): UseGetListReportsResult => {
    const listQuery = useSmoltReportController_listReports(cageId, options);

    const reports = useMemo(
        () => mapSmoltReportListToDomain(listQuery.data?.data ?? []),
        [listQuery.data?.data]
    );

    return {
        ...listQuery,
        isLoading: listQuery.isPending,
        data: reports,
    };
};
